import { EnableGarminConnect, GarminConnectSyncEnabled } from './garmin-connect';
import {
  EnableAppleHealth,
  ConnectAppleWatch,
  InstallWatchCompanionApp,
} from './apple-health';
import {
  EnableHealthConnect,
  InstallHealthConnect,
} from './health-connect';
import { DoYouHaveATrackingDevice } from './shared';
import SupportedDevices from './shared/SupportedDevices';

const garminConnectOnboardingScreens = (headerOptionsForOnboardingStack) => ({
  GarminConnectOnboardingFlow: {
    screen: EnableGarminConnect,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
  GarminConnectSyncEnabled: {
    screen: GarminConnectSyncEnabled,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
});

const appleHealthOnboardingScreens = (headerOptionsForOnboardingStack) => ({
  AppleHealthOnboardingFlow: {
    screen: EnableAppleHealth,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
  ConnectAppleWatch: {
    screen: ConnectAppleWatch,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
  InstallWatchCompanionApp: {
    screen: InstallWatchCompanionApp,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
  DoYouHaveATrackingDevice: {
    screen: DoYouHaveATrackingDevice,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
});

const healthConnectOnboardingScreens = (headerOptionsForOnboardingStack) => ({
  HealthConnectOnboardingFlow: {
    screen: EnableHealthConnect,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
  InstallHealthConnect: {
    screen: InstallHealthConnect,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
});

const sharedOnboardingScreens = (headerOptionsForOnboardingStack) => ({
  SupportedDevices: {
    screen: SupportedDevices,
    navigationOptions: ({ navigation }) => headerOptionsForOnboardingStack(navigation),
  },
});

export const getConnectedAppOnboardingScreens = (headerOptionsForOnboardingStack) => ({
  ...garminConnectOnboardingScreens(headerOptionsForOnboardingStack),
  ...appleHealthOnboardingScreens(headerOptionsForOnboardingStack),
  ...healthConnectOnboardingScreens(headerOptionsForOnboardingStack),
  ...sharedOnboardingScreens(headerOptionsForOnboardingStack),
});
